"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _utils = require("@/utils");
var _livenessDossierStatus = require("@/utils/livenessDossierStatus");
var _default2 = exports.default = {
  name: 'CardValidaDocuments',
  components: {
    Card: _components.Card
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      validations: [],
      validationItem: {},
      totalItems: 0,
      isImageModalActive: false,
      imgSelected: null
    };
  },
  computed: {
    hasDocumentContent: function hasDocumentContent() {
      return Boolean(this.normalizedDocumentItems.length || this.reasonDocument);
    },
    documentData: function documentData() {
      return this.data || {};
    },
    documentoscopia: function documentoscopia() {
      var _this$documentData$do;
      return (_this$documentData$do = this.documentData.documentoscopia) !== null && _this$documentData$do !== void 0 ? _this$documentData$do : null;
    },
    isDocumentCompleted: function isDocumentCompleted() {
      var _this$data;
      return ['completed', 'concluido', 'concluído'].includes(String(((_this$data = this.data) === null || _this$data === void 0 ? void 0 : _this$data.status) || '').trim().toLowerCase());
    },
    reasonDocument: function reasonDocument() {
      var hasDocumentoscopia = this.documentoscopia !== null && this.documentoscopia !== undefined && this.documentoscopia !== '';
      return hasDocumentoscopia ? _utils.StatusDocument.fromString(String(this.documentoscopia)) : '';
    },
    normalizedDocumentItems: function normalizedDocumentItems() {
      var _this = this;
      var documents = Array.isArray(this.documentData.documents) ? this.documentData.documents : [];
      var types = Array.isArray(this.documentData.documentType) ? this.documentData.documentType : [];
      var side = Array.isArray(this.documentData.side) ? this.documentData.side : [];
      return documents.map(function (item, index) {
        var type = (item === null || item === void 0 ? void 0 : item.type) || types[index] || _this.documentData.documentType || 'Documento';
        var position = side[index] ? " ".concat(side[index]) : '';
        return {
          key: "document-".concat(index),
          src: _this.normalizeImageSource(item),
          type: type,
          label: "".concat(type).concat(position),
          helper: 'Toque na imagem para visualizar em tamanho ampliado.',
          raw: item
        };
      }).filter(function (item) {
        return item.src;
      });
    },
    coverDocumentImage: function coverDocumentImage() {
      var _this$normalizedDocum;
      return ((_this$normalizedDocum = this.normalizedDocumentItems[0]) === null || _this$normalizedDocum === void 0 ? void 0 : _this$normalizedDocum.src) || null;
    },
    documentSummary: function documentSummary() {
      if (!this.isDocumentCompleted || !this.reasonDocument) {
        return {
          title: 'Documentação recebida',
          description: 'Os arquivos foram organizados em um layout mais claro para consulta do detalhamento.',
          tagLabel: 'Em análise',
          tagClass: 'is-warning',
          icon: 'clock-outline'
        };
      }
      var documentOutcome = (0, _livenessDossierStatus.getDocumentValidationOutcome)(this.documentoscopia);
      if (documentOutcome === 'approved') {
        return {
          title: 'Documentação validada',
          description: 'A análise documental retornou um cenário favorável, sem risco relevante aparente.',
          tagLabel: 'Aprovado',
          tagClass: 'is-success',
          icon: 'check-circle'
        };
      }
      if (documentOutcome === 'attention') {
        return {
          title: 'Documentação inconclusiva',
          description: 'Existem pontos que exigem atenção ou inviabilizam uma conclusão automática da validação.',
          tagLabel: 'Atenção',
          tagClass: 'is-warning',
          icon: 'alert-circle-outline'
        };
      }
      return {
        title: 'Documentação com ressalvas',
        description: 'A análise documental identificou risco ou divergência que merece acompanhamento mais cuidadoso.',
        tagLabel: 'Risco',
        tagClass: 'is-danger',
        icon: 'alert-circle'
      };
    }
  },
  methods: {
    normalizeImageSource: function normalizeImageSource(item) {
      var image = typeof item === 'string' ? item : item === null || item === void 0 ? void 0 : item.image;
      if (!image) {
        return '';
      }
      if (image.includes('http') || image.startsWith('data:')) {
        return image;
      }
      return "data:image/png;base64,".concat(image);
    },
    openModal: function openModal(img) {
      this.imgSelected = (img === null || img === void 0 ? void 0 : img.src) || this.normalizeImageSource((img === null || img === void 0 ? void 0 : img.raw) || img);
      this.isImageModalActive = true;
    }
  }
};